
import { Vue, Component } from "vue-property-decorator";
import { AmplifyEventBus } from "aws-amplify-vue";
import auth from "@/services/auth";

import AuthCard from "@/components/auth/AuthCard.vue";
import UiButton from "@/components/button/ui-button.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';
import { parseConfirmationQuery } from "@/utils/parseConfirmationQuery";

@Component({
  components: {
    AuthCard,
    UiButton,
  },
})
export default class VerifyAccount extends Vue {
  verifying: boolean = true;
  username: string = "";
  confirmationCode: string = "";

  created(): void {
    this.verify();
  }

  async verify(): Promise<void> {
    const [username, confirmation_code] = parseConfirmationQuery(this.$route.query);
    if (username && confirmation_code) {
      return await this.submit(
        decodeURIComponent(username as string).replace(" ", "+"),
        confirmation_code as string,
      );
    } 

    this.$eventBus.emit(
      NOTIFICATION,
      Message.errorMessage("Credentials not found")
    );
    this.verifying = false;
  }

  async submit(email: string, code: string): Promise<void> {
    try {
      await auth.confirmSignUp(email, code);
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage("Success! Redirecting to signin..."),
      );
    } catch (e) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.errorMessage(e.message),
      );
    } finally {
      this.verifying = false;
    }
  }

  toSignIn(): void {
    AmplifyEventBus.$emit("authState", "signIn");
  }
}
